import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFCF9]">
        <Loader2 className="w-8 h-8 animate-spin text-[#C8553D]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/app/login" replace state={{ from: location }} />;
  }

  return children;
}
